import { render } from "./ProdAction.vue?vue&type=template&id=62a35f4a&scoped=true"
import script from "./ProdAction.vue?vue&type=script&lang=js"
export * from "./ProdAction.vue?vue&type=script&lang=js"

import "./ProdAction.vue?vue&type=style&index=0&id=62a35f4a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a35f4a"]])

export default __exports__